import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IInternDetailsSchema } from '../types';
import { InternDetailsRow } from './intern-details-row';

const TABLE_HEAD = [
  { id: 'id', label: 'Id', align: 'center', sortable: false },
  { id: 'status', label: 'Status', align: 'center' },
  { id: 'reason', label: 'Reason', align: 'center', sortable: false },
  { id: 'actionTime', label: 'Action Time', align: 'center' },
  { id: 'actionBy', label: 'Action By', align: 'center', sortable: false },
  { id: 'interviewer', label: 'Interviewer', align: 'center', sortable: false },
];

interface Props {
  tableProps: TableProps;
  data?: IInternDetailsSchema[];
  loading?: boolean;
}

const InternDetailsListPage = ({ tableProps, data, loading }: Props) => {
  return (
    <PaginatedTable<IInternDetailsSchema>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={data}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => <InternDetailsRow row={row} />}
    </PaginatedTable>
  );
};

export { InternDetailsListPage };
